import React, { useState, ChangeEvent, FormEvent } from 'react';
import { Container, Button, Typography, Box, Alert } from '@mui/material';
import workAnalyzerService from '../services/workAnalyzerService';

const FileUpload: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [message, setMessage] = useState<string>('');

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      setFile(event.target.files[0]);
    }
  };

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!file) {
      setMessage('Please select a file to upload');
      return;
    }
    const result = await workAnalyzerService.upload(file);
    setMessage(result?.filename ? `File uploaded successfully: ${result.filename}` :  `File upload failed.`);
  };

  return (
    <Container component="main" maxWidth="sm" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box sx={{ mt: 4, width: '100%' }}>
        <Typography component="h1" variant="h5" gutterBottom>
          File Upload
        </Typography>
        <Box component="form" onSubmit={handleSubmit} encType="multipart/form-data" sx={{ mt: 2 }}>
          <Button
            variant="contained"
            component="label"
            fullWidth
            sx={{ mt: 2 }}
          >
            Select image to upload
            <input
              type="file"
              hidden
              onChange={handleFileChange}
            />
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
          >
            Upload Image
          </Button>
        </Box>
        {message && (
          <Alert severity={message.includes('successfully') ? 'success' : 'error'} sx={{ mt: 2, width: '100%' }}>
            {message}
          </Alert>
        )}
      </Box>
    </Container>
  );
};

export default FileUpload;
